<template>
  <QCard
    class="lg:hover:-tw-translate-y-4 tw-duration-200 tw-shadow-sm tw-rounded-md tw-overflow-hidden"
  >
    <NuxtLink :to="props.path" :title="props.title">
      <div :class="props.horizontal && 'tw-grid lg:tw-grid-cols-[505px_1fr]'">
        <div class="tw-w-full tw-relative tw-overflow-hidden">
          <BadgeRecommended v-if="props.recommended" />
          <MediaImageLazyLoad
            :src="props.image?.medium || ''"
            :placeholder-src="props.image?.tiny || ''"
            :alt="props.title"
            height="auto"
            :class="[
              'tw-w-full tw-overflow-hidden article-card-image',
              !props.isHomepage &&
                (props.horizontal ? 'tw-rounded-l-lg' : 'tw-rounded-t-lg'),
            ]"
            seo-optimize
            @click="emit('click')"
          />
        </div>
        <div class="lg:tw-pt-16 lg:tw-p-8 tw-p-5" :class="customPaddingContent">
          <div
            class="tw-text-dark-gray tw-text-mb-body-small lg:tw-text-dt-body-small tw-flex tw-items-center tw-mb-2"
          >
            <QIcon name="calendar_today" class="tw-mr-1" />
            {{ formattedDate }}
          </div>

          <component
            :is="props.titleTag"
            class="tw-text-mb-title-4 lg:tw-text-dt-title-4 tw-text-black tw-line-clamp-2 tw-mb-2 tw-min-h-[2lh]"
          >
            {{ props.title }}
          </component>

          <div
            class="tw-text-mb-body-small lg:tw-text-dt-body-small tw-text-secondary tw-truncate tw-mb-1"
          >
            {{ props.categoryTitle }}
          </div>

          <p
            :class="[
              'tw-text-mb-body-small lg:tw-text-dt-body-small tw-text-dark-gray tw-line-clamp-2',
              props.horizontal ? 'tw-truncate-2-lines' : 'tw-truncate-3-lines',
            ]"
          >
            {{ props.description }}
          </p>
        </div>
      </div>
    </NuxtLink>
  </QCard>
</template>

<script setup lang="ts">
const props = defineProps({
  image: {
    type: Object as PropType<ImageMeta>,
    required: true,
  },
  publishedAt: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  categoryTitle: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: "",
  },
  path: {
    type: String,
    required: true,
  },
  horizontal: {
    type: Boolean,
    default: false,
  },
  titleTag: {
    type: String,
    default: "h3",
  },
  recommended: {
    type: Boolean,
    default: false,
  },
  customPaddingContent: {
    type: String,
    default: "",
  },
  isHomepage: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const { $shortDateFormat } = useNuxtApp();
const formattedDate = ref("-");
onMounted(() => {
  formattedDate.value = props.publishedAt
    ? ($shortDateFormat(props.publishedAt) as string)
    : "-";
});
</script>

<style scoped>
.q-card {
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.05);
}

:deep(.q-img__image) {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
</style>
